import { Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { EmployeeGroupMapper } from "features/planner/planner.mappers";

const initialState = Map();

export default (state = initialState, action) => {
  const { type, payload, error } = action;

  switch (type) {
    case ACTIONS.GET_EMPLOYEE_GROUPS: {
      if (error) return state;
      return Map(
        payload.map(employeeGroup => [
          employeeGroup.employeeGroupId.toString(),
          EmployeeGroupMapper.from(employeeGroup),
        ]),
      );
    }
    case ACTIONS.CREATE_EMPLOYEE_GROUP:
    case ACTIONS.UPDATE_EMPLOYEE_GROUP: {
      if (error) return state;

      return state.set(
        payload.employeeGroupId.toString(),
        EmployeeGroupMapper.from(payload),
      );
    }
    case ACTIONS.DELETE_EMPLOYEE_GROUP: {
      if (error) return state;
      return state.delete(action.employeeGroupId.toString());
    }
    default:
      return state;
  }
};
